export default function RegimesCardMock() {
  const volatility = [
    { label: 'Low', pct: 45, color: '#22c55e' },
    { label: 'Med', pct: 19, color: '#eab308' },
    { label: 'High', pct: 37, color: '#ef4444' },
  ];
  const trend = [
    { label: 'Trending', pct: 55, color: '#3b82f6' },
    { label: 'Ranging', pct: 25, color: '#6b7280' },
    { label: 'Transition', pct: 21, color: '#a855f7' },
  ];

  const StackedBar = ({ items }: { items: typeof volatility }) => (
    <div style={{ display: 'flex', borderRadius: 4, overflow: 'hidden', height: 14, marginBottom: 4 }}>
      {items.map((item, i) => (
        <div
          key={i}
          style={{ flex: item.pct, background: item.color, position: 'relative' }}
          title={`${item.label}: ${item.pct}%`}
        />
      ))}
    </div>
  );

  const Legend = ({ items }: { items: typeof volatility }) => (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: '0.75rem' }}>
      {items.map((item, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.625rem', color: '#9ca3af' }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: item.color, display: 'inline-block' }} />
          {item.label} {item.pct}%
        </div>
      ))}
    </div>
  );

  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#a855f7' }} /> Regimes</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={{
          fontSize: '0.5625rem',
          fontWeight: 700,
          color: '#6b7280',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginBottom: '0.25rem',
        }}>
          Volatility Distribution
        </div>
        <StackedBar items={volatility} />
        <Legend items={volatility} />

        <div style={{
          fontSize: '0.5625rem',
          fontWeight: 700,
          color: '#6b7280',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginBottom: '0.25rem',
        }}>
          Trend Structure
        </div>
        <StackedBar items={trend} />
        <Legend items={trend} />

        <div style={{
          fontSize: '0.6875rem',
          color: '#6b7280',
          fontStyle: 'italic',
          marginTop: 'auto',
          paddingTop: '0.5rem',
        }}>
          Mixed-regime backtest — covers a range of market conditions.
        </div>
      </div>
      <div className="platform-mock-caption">
        Regimes shows the mix of volatility and trend conditions present during the backtest period.
      </div>
    </div>
  );
}
